import { CONTAINER_WIDTH, CONTAINER_MARGINS, NUMBER_OF_COLUMNS } from 'ds/components/grid-system';
import { BreakpointValue } from 'consts/breakpoints';

export interface CarouselItemProps {
  currentScreenBreakpoint: BreakpointValue;
  // width of a card in columns (i.e. 3 columns from 12 means that in carousel will be 4 cards)
  cardsColumnsNumber: Record<BreakpointValue, number>;
  showNextSlideStart?: Partial<Record<BreakpointValue, boolean>>;
  autoWidth?: boolean;
}

// percentage of the container that will be filled by next slide part;
const LAST_SLIDE_GAP_WIDTH: Record<BreakpointValue, number> = {
  1: 0.1,
  2: 0.1,
  3: 0.1,
  4: 0.1,
  5: 0.1,
};

export const calculateWidth = ({
  currentScreenBreakpoint,
  cardsColumnsNumber,
  showNextSlideStart = {},
}: CarouselItemProps) => {
  switch (currentScreenBreakpoint) {
    case 1:
    case 2: {
      return `calc((100vw - ${
        parseInt(CONTAINER_MARGINS[currentScreenBreakpoint], 10) * 2
      }px) / ${NUMBER_OF_COLUMNS} * ${
        cardsColumnsNumber[currentScreenBreakpoint]
      } * ${
        showNextSlideStart[currentScreenBreakpoint] ? (1 - LAST_SLIDE_GAP_WIDTH[currentScreenBreakpoint]) : 1
      })`;
    }
    case 3:
    case 4:
    case 5: {
      let value = parseInt(CONTAINER_WIDTH[currentScreenBreakpoint], 10) / NUMBER_OF_COLUMNS * cardsColumnsNumber[currentScreenBreakpoint];

      if (showNextSlideStart[currentScreenBreakpoint]) {
        value = value * (1 - LAST_SLIDE_GAP_WIDTH[currentScreenBreakpoint]);
      }

      return `${value}px`;
    }
  }
};
